export const isString = (obj: unknown): obj is string => typeof obj === 'string';
